"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetFromTimeZone = void 0;
const getOffsetFromTimeZone = (timeZone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    return tzPart ? parseInt(tzPart.value.replace('GMT', '')) : undefined;
};
exports.getOffsetFromTimeZone = getOffsetFromTimeZone;
